<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <div class="form-wrapper clearfix">
        <form class="form-custom" @submit.prevent="loginHandle" novalidate="novalidate">

          <div class="form-group has-feedback" :class="{'has-success': (checkPhone != null) && checkPhone,'has-error': (checkPhone != null) && !checkPhone}">
            <label class="control-label">手机号</label>
            <div>
              <input class="form-control" type="tel" v-model="phone" ref="input" maxlength="11" placeholder="请输入手机号" @blur="validatePhone">
            </div>
            <span class="glyphicon form-control-feedback" v-show="checkPhone != null" :class="{'glyphicon-ok': checkPhone,'glyphicon-remove': !checkPhone}"></span>
            <span class="help-block">{{phoneMsg}}</span>
          </div>
          <div class="form-group has-feedback" :class="{'has-success': (checkPassword != null) && checkPassword,'has-error': (checkPassword != null) && !checkPassword}">
            <label class="control-label">密码</label>
            <div>
              <input class="form-control" type="password" v-model="password" placeholder="请输入6-16位数字字母的组合" @blur="validatePassword">
            </div>
            <span class="glyphicon form-control-feedback" v-show="checkPassword != null" :class="{'glyphicon-ok': checkPassword,'glyphicon-remove': !checkPassword}"></span>
            <span class="help-block">{{passwordMsg}}</span>
          </div>
          <div class="form-group capt-box has-feedback" :class="{'has-success': (checkCapt != null) && checkCapt,'has-error': (checkCapt != null) && !checkCapt}">
            <label class="control-label">验证码</label>
            <div>
              <input class="form-control input-capt" type="text" v-model="capt" maxlength="4" placeholder="请输入验证码" @blur="validateCapt">
            </div>
            <span class="glyphicon form-control-feedback" v-show="checkCapt != null" :class="{'glyphicon-ok': checkCapt,'glyphicon-remove': !checkCapt}"></span>
            <span class="help-block">{{captMsg}}</span>
            <div class="capt">
              <a href="javascript:;" title="点击更换验证码" @click="updateCapt"><img :src="captUrl"></a>
            </div>
          </div>
          <div class="form-group btn-wrap">
             <p class="err-wrap"><span>{{errmsg}}</span>&nbsp;</p>
            <button class="btn" type="submit">登录<span class="iconfont">&#xe65a;</span></button>
            <div class="forget-pass">
              <a href="javascript:;" @click="toFindPass">忘记密码？</a>
            </div>
          </div>
        </form>
        <div class="form-about-me">
          <h2 class="title">关于我们</h2>
          <p class="desc">北京伟嘉安捷投资担保有限公司成立于2006年3月15日。是一家为个人提供房产按揭引荐服务、房产权证服务的专业机构，注册资金为5000万元。</p>
          <div class="register-box">
            <button class="register-btn" type="button" @click="toRegister">注册新账号<span class="iconfont">&#xe65a;</span></button>
          </div>
        </div>
      </div>
      <div class="copy">
        &copy; 2017 <span>北京伟嘉安捷投资担保有限公司</span> All rights reserved&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;京ICP备16040229号-2
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        captUrl: '',
        errmsg: '',
        checkPhone: null,
        phoneMsg: '',
        checkPassword: null,
        passwordMsg: '',
        checkCapt: null,
        captMsg: '',
        phone: '',
        password: '',
        capt: ''
      }
    },
    created () {
      this.updateCapt()
    },
    watch: {
      phone (newVal) {
        // this.validatePhone()
      }
    },
    methods: {
      updateCapt () {
        this.$store.commit('updateCaptId')
        this.captUrl = '/captchaImage.jhtml?captId=' + this.$store.state.captId + '&sr=0'
      },
      validatePhone () {
        this.checkPhone = this.validate('phone')
        this.checkPhone && (this.phoneMsg = '')
        !this.checkPhone && (this.errmsg = '')
      },
      validatePassword () {
        this.checkPassword = this.validate('password')
        this.checkPassword && (this.passwordMsg = '')
        !this.checkPassword && (this.errmsg = '')
      },
      validateCapt () {
        this.checkCapt = this.validate('capt')
        this.checkCapt && (this.captMsg = '')
        !this.checkCapt && (this.errmsg = '')
      },
      validate (choice) {
        let rules = {
          phone: {
            patterns: [{
              pattern: this.$validate.patterns.phone,
              msg: '请输入正确的手机号'
            }],
            required: '请输入手机号'
          },
          password: {
            patterns: [{
              pattern: this.$validate.patterns.password,
              msg: '密码应为6-16位字母数字的组合，且不能包含空格'
            }],
            required: '请输入密码'
          },
          capt: {
            patterns: [{
              pattern: this.$validate.patterns.capt,
              msg: '请输入正确的验证码'
            }],
            required: '请输入验证码'
          }
        }
        if (choice) {
          let obj = {}
          obj[choice] = rules[choice]
          rules = obj
        }
        // let msgField = choice ? choice + 'Msg' : 'errmsg'
        return this.$validate({rules})
      },
      loginHandle (e) {
        if (this.validate()) {
          let vm = this
          this.$http({
            url: '/login.jhtml',
            data: {
              phone: this.phone,
              password: this.$md5(this.password),
              captId: this.$store.state.captId,
              captText: this.capt
            },
            done (info) {
              let {uid, mac, status} = info || {}
              vm.$store.commit('updateToken', {
                uid,
                mac,
                status,
                phone: vm.phone
              })
              // if (vm.$store.state.redirect && vm.$store.state.redirect !== vm.$route.fullPath) {
              //   vm.$router.push(vm.$store.state.redirect)
              // }
              let backurl = vm.$route.query.backurl
              if (backurl) {
                window.location.href = backurl
                return
              }
              if (status === 0) {
                vm.$router.push('/authentication')
              } else {
                vm.$router.push('/')
              }
            },
            fail (m) {
              vm.errmsg = m
              vm.updateCapt()
            }
          })
        }
      },
      toFindPass (e) {
        this.$router.push('/findpass')
      },
      toRegister (e) {
        this.$router.push('/register')
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .form-wrapper
    width 946px
    margin 65px auto 100px
    // height 540px
    .form-custom
      float left
      width 620px
      height 560px
      padding 46px 40px 22px 60px
      box-shadow none
      .forget-pass
        position absolute
        right 50px
        bottom 0
        color #2b9efc
        a
          color #2b9efc
        a:hover, a:focus
          color #2b9efc
    .form-about-me
      position relative
      float right
      width 326px
      height 560px
      padding 127px 40px 40px
      background-color rgba(1, 23, 40, 0.9)
      .title
        font-size 28px
        margin 0
        letter-spacing 6px
        color #fff
      .desc
        margin-top 46px
        font-size 14px
        letter-spacing 1px
        color #fff
        line-height 25px
      .register-btn
        position absolute
        bottom 40px
        width 246px
        height 62px
        color #fff
        letter-spacing 4px
        background-color transparent
        border 1px solid #fff
        .iconfont
          letter-spacing 0
          position absolute
          width 18px
          height 18px
          right 30px
          transform rotateZ(-90deg)
  .copy
    text-align center
    margin-bottom 10px
    font-size 12px
    color #fff
    span
      color #2b9efc
</style>



// WEBPACK FOOTER //
// login.vue?5fc29b22